import { render, staticRenderFns } from "./ArrangeAtomicOrbitals.vue?vue&type=template&id=1c0db807&scoped=true&"
import script from "./ArrangeAtomicOrbitals.vue?vue&type=script&lang=js&"
export * from "./ArrangeAtomicOrbitals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0db807",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VContainer,VForm})
